import ScrollMagic from 'scrollmagic';
import { jarallax, jarallaxVideo } from 'jarallax';

export default {
	itemReveal() {
		// reveals
		// eslint-disable-next-line no-unused-vars
		var $itemReveals = $('.reveal')
			.not('.revealed')
			.waypoint({
				handler: function () {
					$(this)[0].element.classList.add('revealed');
				},
				offset: '75%',
			});
	},
	buttonHover() {
		// https://codepen.io/gabrielcojea/pen/GRpZbZL
		let elements = document.querySelectorAll('.btn, .vc_btn3');

		elements.forEach((element) => {
			let innerText = element.innerText;
			element.innerHTML = '';

			let textContainer = document.createElement('div');
			textContainer.classList.add('block');

			// for ...of caused a webpack error. fixed in webpack.config.js, reference https://discourse.roots.io/t/for-of-statements-are-not-supported/12749
			for (const letter of innerText) {
				let span = document.createElement('span');
				span.innerText = letter.trim() === '' ? '\xa0' : letter;
				span.classList.add('letter');
				textContainer.appendChild(span);
			}

			element.appendChild(textContainer);
			element.appendChild(textContainer.cloneNode(true));
		});
	},
	contentToggle() {
		let $toggleWrap = $('.content-toggle-wrap');

		if ($toggleWrap.length) {
			$toggleWrap.each(function () {
				let $toggleLink = $(this).find('.content-toggle-link'), // link
					$toggleContent = $(this).find('.content-toggle'); // content to toggle

				$toggleLink.click(function (e) {
					e.preventDefault();
					$toggleContent.slideToggle();
					let text = ($(this).text() === 'See Less') ? 'See More' : 'See Less';
					$(this).text(text);
				})
			});
		}

	},
	mobileNav() {
		/** RESPONSIVE NAV OPEN/CLOSE **/
		var body = document.querySelector('body'),
			mobileNav = document.querySelector('#mobile-nav'),
			mobileNavButton = document.querySelector('#mobile-nav-icon');

		// Toggle menu icon
		if (mobileNavButton) {
			mobileNavButton.addEventListener('click', function () {
				body.classList.toggle('mobile-nav-open');
			});
		}

		// Close menu if page is clicked (not menu item)
		if (mobileNav) {
			mobileNav.addEventListener('click', function (e) {
				// Don't hide if click is on a child element (nav link)
				if (e.target !== this) {
					return;
				}
				mobileNavButton.classList.toggle('opened');
				$('#nav-toggle').prop('checked', false);
			});
		}
	},
	header() {
		var body = document.querySelector('body');

		/* HEADER SCROLL EFFECT */
		// Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
		// eslint-disable-next-line no-unused-vars
		var animatedHeader = (function () {
			// eslint-disable-line no-unused-vars
			var didScroll = false,
				scrollOffset = 0;

			function scrollY() {
				return window.pageYOffset || document.documentElement.scrollTop;
			}

			function scrollPage() {
				var sy = scrollY();
				if (sy > scrollOffset) {
					body.classList.add('scroll-triggered');
				} else {
					body.classList.remove('scroll-triggered');
				}
				didScroll = false;
			}

			function init() {
				window.addEventListener('load', scrollPage);
				window.addEventListener(
					'scroll',
					function () {
						// eslint-disable-line no-unused-vars
						// console.log(scrollY());

						if (!didScroll) {
							didScroll = true;
							setTimeout(scrollPage, 50);
						}
					},
					false
				);
			}
			init();
		})();
		/* END HEADER SCROLL EFFECT */

		/** Header Animation */
		// var lastScrollPosition = 0;
		// var $header = $('.header');
		// var $headerElements = $(
		//     '.header__brand, .header__social, .mobile-nav__icon'
		// );

		// function headerReveal() {
		//     var scrollPosition = $(window).scrollTop();
		//     if (scrollPosition > 50) {
		//         if (scrollPosition < lastScrollPosition) {
		//             $headerElements.css(
		//                 {
		//                     transform: 'translateY(0)',
		//                     opacity: 1,
		//                     // 'background-color': '#fff',
		//                 },
		//                 750,
		//                 'ease-in-out'
		//             );
		//             $header.addClass('header--scroll-active');
		//         } else {
		//             $headerElements.css(
		//                 {
		//                     transform: 'translateY(-100px)',
		//                     opacity: 0,
		//                 },
		//                 750,
		//                 'ease-in-out'
		//             );
		//             $header.removeClass('header--scroll-active');
		//         }
		//         lastScrollPosition = scrollPosition;
		//     } else {
		//         // $header.css({ 'background-color': 'transparent' }, 750, 'ease-in-out');
		//         $header.removeClass('header--scroll-active');
		//     }
		// }

		// $(window).scroll(function () {
		//     headerReveal();
		// });
	},
	masthead() {
		/** MASTHEAD PRGRESSIVE IMAGES **/
		var mastheadOverlay = document.querySelector('.masthead__overlay'),
			masthead = document.querySelector('.masthead'),
			imageMasthead = document.querySelector(
				'.masthead--full.masthead--img-bg'
			);

		if (mastheadOverlay) {
			// Load full size image. When loaded, add it as a background image to the div
			if (mastheadOverlay.dataset.imageSrc) {
				var img = new Image();
				img.src = mastheadOverlay.dataset.imageSrc;
				img.onload = function () {
					mastheadOverlay.style.backgroundImage =
						'url(' + img.src + ')';
					masthead.classList.add('fade-in');
				};
			}
		} else if (masthead) {
			// no masthead image is set, load in content
			masthead.classList.add('fade-in');
		}
		/** END MASTHEAD PRGRESSIVE IMAGES **/

		// Fade masthead on scroll
		if (imageMasthead) {
			$(window).scroll(function () {
				// Only until opacity reaches 0. $(window).scroll() is unneeded/intensive past that hit
				let $opacity =
					1 -
					$(window).scrollTop() /
					($('.masthead__overlay').height() / 2);
				// if ($opacity > 0) {
				$('.masthead__overlay').css('opacity', $opacity);
				// }
			});
		}
	},
	scrollMagic() {
		// get all triggers - headers of all 3 slides
		let blocks = document.querySelectorAll('.scrolling-content__block'),
			triggerHook = 0.5;

		if ($(window).width() >= 992) {
			triggerHook = 0.9;
		}

		if (blocks) {
			// Init ScrollMagic
			var controller = new ScrollMagic.Controller();

			// create scenes for each of the blocks
			blocks.forEach(function (block, index) {
				// number for highlighting scenes
				var num = index + 1;

				// make scene
				// eslint-disable-next-line no-unused-vars
				var blockScene = new ScrollMagic.Scene({
					triggerElement: block,
					// offset: 95,
					triggerHook: triggerHook,
				})
					.setClassToggle('#img-block-' + num, 'is-active')
					.addTo(controller);
			});
		}
	},
	slick() {
		if ($('.visceral-slider').length > 0) {
			var slider = $(
				'.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper'
			);

			slider.slick({
				slide:
					'.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper > *',
				autoplay: false,
				fade: true,
				speed: 1200,
				infinite: true,
				cssEase: 'ease',
				slidesToShow: 1,
				slidesToScroll: 1,
				swipeToSlide: true,
				dots: true,
				arrows: true,
				mobileFirst: true,
				rows: 0,
				nextArrow:
					'<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><i class="icon-arrow-right"></i></button>',
				prevArrow:
					'<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><i class="icon-arrow-left"></i></button>',
			});
		}
	},
	jarallax() {
		// Jarallax (for background videos)
		// TODO: add fade in once video is loaded and playing
		if (document.querySelector('.jarallax')) {
			jarallaxVideo();

			jarallax(document.querySelectorAll('.jarallax'), {
				speed: 0.5,
				videoPlayOnlyVisible: false,
			});
		}

		// Fade masthead on scroll (only on full height mastheads)
		if (document.querySelector('.masthead--full .jarallax')) {
			$(window).scroll(function () {
				// Only until opacity reaches 0. $(window).scroll() is unneeded/intensive past that hit
				let $opacity =
					1 -
					$(window).scrollTop() /
					($('.masthead .jarallax').height() / 2);
				if ($opacity > -0.5) {
					$('.masthead .jarallax').css('opacity', $opacity);
				}
			});
		}
	},
	magnificPopup() {
		// Modal Pop-ups
		$('.link--modal').magnificPopup({
			type: 'inline',
			midClick: true,
			callbacks: {
				beforeOpen: function () {
					$('html').css('overflow', 'hidden');
				},
				beforeClose: function () {
					$('html').css('overflow', 'auto');
				},
			},
			// closeMarkup:
			//     '<button title="%title%" type="button" class="mfp-close"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.7516 40L0 3.24841L3.24841 0L40 36.7516L36.7516 40Z" fill="#797979" /><path fill-rule="evenodd" clip-rule="evenodd" d="M2.57063e-05 36.7516L36.7516 1.17682e-06L40 3.24841L3.24844 40L2.57063e-05 36.7516Z" fill="#797979" /></svg></button>',
		});

		$('.list-item-bio__link').magnificPopup({
			type: 'ajax',
			callbacks: {
				parseAjax: function (mfpResponse) {
					// Add crew memeber's slug to current URL
					let href = this.currItem.src;
					href = href.replace(/\/+$/, ''); // remove trailing slash
					let name = href.substring(href.lastIndexOf('/') + 1);
					location.hash = name;

					mfpResponse.data = $(mfpResponse.data).find('.single-bio');
				},
				beforeOpen: function () {
					$('html').css('overflow', 'hidden');
				},
				beforeClose: function () {
					$('html').css('overflow', 'auto');
				},
			},
			cursor: 'mfp-ajax-cur',
			midClick: true,
		});
	},
	imageParallax() {
		// Image Element Parallax
		function imageParallax(selector) {
			// Set variables
			var $window = $(window);
			// How far we've scrolled
			var wScroll = $window.scrollTop();
			// Height of window
			var wHeight = $window.height();
			// Position of bottom of window
			var wScrollBottom = wScroll + wHeight;
			// Decoration container
			var $selector = $(selector);

			// Process parallax items
			function processParallax() {
				$selector.each(function () {
					// position of element's top from top of window
					var elTop = $(this).offset().top;
					var speed = $(this).attr('data-parallax-speed');
					var change;
					// If element is in window, change rate is based on scroll
					if (elTop < wHeight) {
						change = wScroll;
						// If element is not in window view, change rate has offset
					} else {
						change = wScrollBottom - elTop;
					}
					// If element is in window do the parallax
					if (wScrollBottom > elTop) {
						$(this).css({
							transform: 'translateY(-' + change / speed + '%)',
						});
					}
				});
			}

			// Process parallax
			processParallax();
		}

		// Do parallax effect
		$(window).scroll(function () {
			imageParallax('.visc-parallax');
			// console.log(window.scrollY);
		});
	},
	init() {
		//-- JavaScript to be fired on all pages
		/** GLOBAL VARIABLES */
		var masthead = this.masthead(),
			imageParallax = this.imageParallax();

		// Page load
		window.addEventListener('load', function () {
			// Masthead behavior
			masthead;

			// parallax
			imageParallax;
		});

		// reveal animations
		this.itemReveal();

		this.contentToggle();

		// Animated button hover
		// if (window.innerWidth > 768) {
		//     // Only do this if it's not mobile
		//     this.buttonHover();
		// }

		// Header behavior
		this.header();

		// responsive nav
		this.mobileNav();

		// jarallax
		this.jarallax();

		// scroll magic
		this.scrollMagic();

		// slick slide
		this.slick();

		// magnific popup
		this.magnificPopup();

		/** SCROLL TO TOP */
		if ($('.to-top').length > 0) {
			$(document).scroll(function () {
				var y = $(this).scrollTop();
				if (y > 400) {
					$('.to-top').fadeIn(250);
				} else {
					$('.to-top').fadeOut(250);
				}
			});
		}

		/** SKIP LINK NAVIGATION */
		$('#skip-to-content').click(function () {
			// strip the leading hash and declare
			// the content we're skipping to
			var skipTo = '#' + this.href.split('#')[1];
			// Setting 'tabindex' to -1 takes an element out of normal
			// tab flow but allows it to be focused via javascript
			$(skipTo)
				.attr('tabindex', -1)
				.on('blur focusout', function () {
					// when focus leaves this element,
					// remove the tabindex attribute
					$(this).removeAttr('tabindex');
				})
				.focus(); // focus on the content container
		});
		/** END SKIP LINK NAVIGATION */

		/** ANIMATED ANCHOR LINKS **/
		$('a[href*="#"]:not([href="#"])').click(function (e) {
			// Doesn't do it on page builder tabs
			if (!$(this).closest('li').hasClass('vc_tta-tab')) {
				if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
					if (
						location.pathname.replace(/^\//, '') ===
						this.pathname.replace(/^\//, '') &&
						location.hostname === this.hostname
					) {
						var target = $(this.hash);
						var $this = this;
						var header = $('header.header');
						var wpAdminBar = $('#wpadminbar');
						var fixedHeaderOffset =
							parseInt(header.outerHeight()) -
							parseInt(
								header.css('padding-top').replace('px', '')
							);
						// If we're logged in and WP ADmin Bar exists, add it to the offset
						if (wpAdminBar.length) {
							fixedHeaderOffset += parseInt(
								wpAdminBar.outerHeight()
							);
						}
						target = target.length
							? target
							: $('[name=' + this.hash.slice(1) + ']');
						if (target.length) {
							$('html,body').animate(
								{
									scrollTop:
										target.offset().top - fixedHeaderOffset,
								},
								500,
								function () {
									if (history.pushState) {
										history.pushState(
											null,
											null,
											$this.hash
										);
									} else {
										location.hash = $this.hash;
									}
								}
							);
							e.preventDefault();
						}
					}
				}
			}
		});
		/** END ANIMATED ANCHOR LINKS **/

		/** Break link text to new line when link text is a URL **/
		$(document).ready(function () {
			$('a').each(function () {
				var $this = $(this);
				var innerLink = $this.text();
				if (innerLink.startsWith('http')) {
					$this.css('word-break', 'break-all');
				}
			});
		});
		/** End Break link text to new line when link text is a URL **/
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		let body = document.querySelector('body');
		// 1. First, remove page overlay
		setTimeout(() => {
			body.classList.remove('loading');
		}, 1500);
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js